import { z } from '@uturn/portal/zod';
import { countryCodeSchema } from './country-code';
import {
	locationActionConceptSchema,
	locationActionPublishSchema,
	type locationSchema,
} from './location-action';

export {
	PORT_MAX_LENGTH,
	REFERENCE_MAX_LENGTH,
	VESSEL_NAME_MAX_LENGTH,
} from './location-action';

export const formLocationConceptSchema = z.object({
	countryCode: countryCodeSchema.optional(),
	action: locationActionConceptSchema.optional(),
});

export const formLocationPublishSchema = z.object({
	countryCode: countryCodeSchema.optional(),
	action: locationActionPublishSchema.optional(),
});

export type ZodLocation =
	| z.infer<typeof formLocationConceptSchema>
	| z.infer<typeof formLocationPublishSchema>;

export type ZodLocationAction =
	| z.infer<typeof locationActionConceptSchema>
	| z.infer<typeof locationActionPublishSchema>;

export type ZodLocationActionLocation = z.infer<typeof locationSchema>;
